// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsList_EventsList__Pi7TR .EventsList_Title__CDtAy {
  margin: 0 0 20px;
}
.EventsList_EventsList__Pi7TR .EventsList_NewEventButton__Urd7F {
  margin: 0 0 20px;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V tr {
  position: relative;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V th:last-child {
  width: 14%;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V td:last-child {
  text-align: center;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V td .EventsList_ActionIconButton__D5uUl {
  border: none;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V td .EventsList_ActionIconButton__D5uUl.EventsList_DeleteEventButton__oBkga .EventsList_Icon__CHe3S {
  color: #d51919;
  width: 100%;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V td .EventsList_ActionIconButton__D5uUl.EventsList_EditEventButton__lNACN {
  margin: 0 10px;
}
.EventsList_EventsList__Pi7TR .EventsList_EventsListTable__enX1V td .EventsList_ActionIconButton__D5uUl.EventsList_EditEventButton__lNACN .EventsList_Icon__CHe3S {
  color: #228be6;
}`, "",{"version":3,"sources":["webpack://./src/components/EventsList/EventsList.module.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,kBAAA;AAFZ;AAMY;EACI,UAAA;AAJhB;AASY;EACI,kBAAA;AAPhB;AAUY;EACI,YAAA;AARhB;AAWoB;EACI,cAAA;EACA,WAAA;AATxB;AAagB;EACI,cAAA;AAXpB;AAaoB;EACI,cAAA;AAXxB","sourcesContent":[".EventsList {\n    .Title {\n        margin: 0 0 20px;\n    }\n\n    .NewEventButton {\n        margin: 0 0 20px;\n    }\n\n    .EventsListTable {\n        width: 100%;\n        border: 1px solid #dee2e6;\n        border-radius: 5px;\n\n        tr {\n            position: relative;\n        }\n\n        th {\n            &:last-child {\n                width: 14%;\n            }\n        }\n\n        td {\n            &:last-child {\n                text-align: center;\n            }\n\n            .ActionIconButton {\n                border: none;\n\n                &.DeleteEventButton {\n                    .Icon {\n                        color: #d51919;\n                        width: 100%;\n                    }\n                }\n\n                &.EditEventButton {\n                    margin: 0 10px;\n\n                    .Icon {\n                        color: #228be6;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EventsList": `EventsList_EventsList__Pi7TR`,
	"Title": `EventsList_Title__CDtAy`,
	"NewEventButton": `EventsList_NewEventButton__Urd7F`,
	"EventsListTable": `EventsList_EventsListTable__enX1V`,
	"ActionIconButton": `EventsList_ActionIconButton__D5uUl`,
	"DeleteEventButton": `EventsList_DeleteEventButton__oBkga`,
	"Icon": `EventsList_Icon__CHe3S`,
	"EditEventButton": `EventsList_EditEventButton__lNACN`
};
export default ___CSS_LOADER_EXPORT___;
